import { render } from "./dappPcIndex.vue?vue&type=template&id=052e8bb1"
import script from "./dappPcIndex.vue?vue&type=script&lang=js"
export * from "./dappPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__